/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectLightDto } from '../../models/core-project-light-dto';

export interface ProjectsControllerFindLight$Params {
  tenant: string;

/**
 * Optional filter by project status
 */
  status?: string;

/**
 * Optional filter by customer ID
 */
  customer?: string;

/**
 * Optional filter by project manager ID
 */
  projectManagerId?: string;

/**
 * Optional filter by project category (PRODUCTIVE or NOT_PRODUCTIVE)
 */
  category?: string;
}

export function projectsControllerFindLight(http: HttpClient, rootUrl: string, params: ProjectsControllerFindLight$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectLightDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectsControllerFindLight.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('status', params.status, {});
    rb.query('customer', params.customer, {});
    rb.query('projectManagerId', params.projectManagerId, {});
    rb.query('category', params.category, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectLightDto>>;
    })
  );
}

projectsControllerFindLight.PATH = '/o2-core/projects/light/{tenant}';
